import { render, staticRenderFns } from "./MerchantInactivation.vue?vue&type=template&id=49f77631&"
import script from "./MerchantInactivation.vue?vue&type=script&lang=js&"
export * from "./MerchantInactivation.vue?vue&type=script&lang=js&"
import style0 from "./MerchantInactivation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports